if (!customElements.get('rsp-team-order')) {
  customElements.define('rsp-team-order', class extends HTMLElement {
    connectedCallback() {
      if (this.submitHandler) return;
      this.submitHandler = this.submit.bind(this);
      this.addEventListener('submit', this.submitHandler);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.submitHandler);
      this.submitHandler = null;
    }
    async submit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.rsp-team-order__form')) return;
      event.preventDefault();
      const personalization = form.querySelector('[data-rsp-personalization]') || form.elements.namedItem('properties[Player Number]');
      if (personalization) personalization.value = personalization.value.trim();
      if (!form.reportValidity() || form.dataset.busy === 'true') return;
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('[data-status]');
      const payload = new FormData(form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sectionIds = cart?.getSectionsToRender?.().map((section) => section.id) || ['cart-icon-bubble'];
      payload.append('sections', sectionIds.join(','));
      payload.append('sections_url', window.location.pathname);
      cart?.setActiveElement?.(button);
      form.dataset.busy = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      let result;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: payload
        });
        result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        status.textContent = this.dataset.added;
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        return;
      } finally {
        delete form.dataset.busy;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      try {
        if (cart && result.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else if (result.sections?.['cart-icon-bubble']) {
          const html = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          const current = document.getElementById('cart-icon-bubble');
          const updated = html.getElementById('cart-icon-bubble') || html.querySelector('.shopify-section');
          if (current && updated) current.innerHTML = updated.innerHTML;
        }
      } catch {
        status.textContent = this.dataset.added;
      }
    }
  });
}
